export const RQ_GET_SCHEDULER_HISTORY_BY_DATE_API = {
  url: 'v2/scheduler-log/history-By-Date/<%= logDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_SCHEDULER_LOG_DETAILS_API = {
  url: 'v2/scheduler-log/log-details/<%= logId %>/<%= logType %>',
  method: 'GET',
  auth: true,
};
